export function userData(value) {
  return { type: "USER_DATA", payload: value};
}
